import { NotificationPatch, NotificationResponse } from "models/notifications"

import { http } from "./http"

export const fetchNotifications = async (_key: string, params?: string) => {
  const searchParams = new URLSearchParams(params)
  const res = await http("notifications", { searchParams }).json()
  return res as NotificationResponse
}

export const fetchMediaPlanNotifications = async (
  _key: string,
  id: string,
  params?: string,
) => {
  const searchParams = new URLSearchParams(params || undefined)
  const res = await http(`notifications/media_plan/${id}`, {
    searchParams,
  }).json()
  return res as NotificationResponse
}

export const markReadAll = async () => {
  await http.patch("notifications/mark-as-read")
  return true
}

export const markReadOne = async (id: string) => {
  await http.patch(`notifications/${id}/mark-as-read`)
  return true
}

export const patchFlag = async (pld: NotificationPatch) => {
  const { id, ...data } = pld
  const res = await http.patch(`notifications/${id}`, { json: data })
  return res
}
